/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST /signatures/email/{id}/publish``.
 *
 * ``revision`` is the optimistic-concurrency token returned by the most
 * recent ``GET`` / ``PATCH`` — guards against publishing stale edits.
 */
export interface EmailSignaturePublish {
  /** @minimum 1 */
  revision: number;
}
